// extracted by mini-css-extract-plugin
export default {"map":"style_map__E+1aS"};